import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import SEO from '@/components/SEO';

const TrustMonitoring = () => {
  return (
    <div>
      <SEO
        title="Trust Monitoring - Continuous Security Posture Monitoring"
        description="Continuous monitoring of your external security posture. SSL/TLS health, email authentication, domain reputation, credential breach exposure, and more."
        keywords="trust monitoring, security monitoring, SSL monitoring, domain reputation, credential breach monitoring, external security posture"
        ogTitle="Trust Monitoring - Continuous Security Posture Monitoring"
        ogDescription="Continuous monitoring of your external security posture. SSL/TLS health, email authentication, domain reputation, credential breach exposure, and more."
        canonicalUrl="https://idnty.one/trust-monitoring"
      />
      {/* Hero */}
      <section className="section-padding" style={{ background: 'var(--white)' }}>
        <div className="container" style={{ textAlign: 'center' }}>
          <h1 className="hero-title" style={{ marginBottom: '1rem' }}>
            TRUST MONITORING
          </h1>
          <p style={{ fontSize: '1.2rem', maxWidth: '640px', margin: '0 auto 2rem', lineHeight: '1.8' }}>
            For companies who already have IAM sorted. If you've implemented an IAM solution and just need continuous monitoring of your external security posture, we offer Trust Monitoring as a standalone product.
          </p>
          <Link to="/contact" className="btn" style={{ marginRight: '0.75rem' }}>Get Started</Link>
          <Link to="/" className="btn btn-secondary">View full IAM services →</Link>
        </div>
      </section>

      {/* What we monitor */}
      <section className="section-padding" style={{ background: 'var(--light-gray)' }}>
        <div className="container">
          <h2 className="section-title" style={{ textAlign: 'center', marginBottom: '2rem' }}>
            WHAT WE MONITOR
          </h2>
          <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '1rem', marginBottom: '2rem' }}>
            {['SSL/TLS health', 'Email authentication (SPF, DKIM, DMARC)', 'Domain reputation', 'Credential breach exposure', 'Certificate transparency', 'Public endpoint uptime'].map((item, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '0.5rem 1rem', background: 'var(--white)', border: '2px solid var(--gray)' }}>
                <CheckCircle size={18} style={{ color: 'var(--success)' }} />
                <span style={{ fontSize: '0.95rem' }}>{item}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Standalone tiers */}
      <section className="section-padding" style={{ background: 'var(--white)' }}>
        <div className="container">
          <h2 className="section-title" style={{ textAlign: 'center', marginBottom: '2rem' }}>
            STANDALONE PRICING
          </h2>
          <div className="grid-2" style={{ maxWidth: '800px', margin: '0 auto' }}>
            <div className="card-heavy" style={{ background: 'var(--white)' }}>
              <div className="label" style={{ color: 'var(--gold)', marginBottom: '0.5rem' }}>Starter</div>
              <div style={{ fontSize: '1.75rem', fontWeight: 700, marginBottom: '0.5rem' }}>Free</div>
              <ul style={{ paddingLeft: '1.25rem', fontSize: '0.95rem', lineHeight: '1.8' }}>
                <li>1 domain</li>
                <li>Basic monitoring</li>
                <li>Email alerts</li>
              </ul>
              <Link to="/contact" className="btn btn-secondary" style={{ width: '100%', textAlign: 'center', marginTop: '1rem' }}>Get Started</Link>
            </div>
            <div className="card-heavy" style={{ background: 'var(--gold)' }}>
              <div className="label" style={{ marginBottom: '0.5rem', color: 'var(--black)' }}>Standard</div>
              <div style={{ fontSize: '1.75rem', fontWeight: 700, marginBottom: '0.5rem', color: 'var(--black)' }}>$199/month</div>
              <ul style={{ paddingLeft: '1.25rem', fontSize: '0.95rem', lineHeight: '1.8', color: 'var(--black)' }}>
                <li>Up to 5 domains</li>
                <li>Full monitoring suite</li>
                <li>Slack integration</li>
                <li>Public status page</li>
              </ul>
              <Link to="/contact" className="btn" style={{ width: '100%', textAlign: 'center', marginTop: '1rem' }}>Get Started</Link>
            </div>
          </div>
        </div>
      </section>

      {/* CTA to full services */}
      <section className="section-padding" style={{ background: 'var(--charcoal)', color: 'var(--white)' }}>
        <div className="container" style={{ textAlign: 'center' }}>
          <p style={{ fontSize: '1.1rem', marginBottom: '1rem' }}>
            Already know you need IAM implementation?
          </p>
          <Link to="/" className="btn btn-gold">
            View full services →
          </Link>
        </div>
      </section>
    </div>
  );
};

export default TrustMonitoring;
